<template lang="html">
  <section class="grid_rules_check">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="grid_rules_check_filters" class="mt-2 ml-4 mr-4" visible>
            <b-card>
              <h4 class="card-text">Filters</h4>
              <b-row>
                <b-col class="col-lg-1 pt-2">Market:</b-col>
                <b-select class="col-lg-5" v-model="filter.country" id="country">
                  <option :value="country" v-for="country in countries">{{ country.description }}</option>
                </b-select>
                <b-col class="col-lg-1 pt-2">Model:</b-col>
                <b-select class="col-lg-5" v-model="filter.model" id="model" v-if="filter.country && filter.country.modelGroupItemList">
                  <template v-for="models in filter.country.modelGroupItemList">
                    <optgroup :label="models.label"><option v-for="(model, index) in models.items" :key="index" :value="model">{{ model.label }}</option></optgroup>
                  </template>
                </b-select>
              </b-row>
              <br>
              <b-row>
                <div class="col-lg-1 pt-2">ConfigId:</div><input type="text" class="col-lg-5" v-model="filter.configId" placeholder="ConfigId" />
                <div class="col-lg-1 pt-2">Config:</div><input type="text" class="col-lg-5" v-model="filter.config" placeholder="Config" />
              </b-row>
              <br>
              <b-row>
                <b-col class="col-lg-1 pt-2">Preview Data:</b-col>
                <b-col class="col-lg-1"><input type="checkbox" v-model="filter.isPreview"/></b-col>
              </b-row>
              <br>
              <b-button variant="primary" v-b-toggle.grid_rules_check_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-8">
              <h4 class="card-title">Grid Rules Check</h4>
            </div>
            <div class="col-lg-4">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="search"><i class="mdi mdi-refresh"></i>Refresh</b-button>
                <b-button variant="primary mr-1" v-b-toggle.grid_rules_check_filters><i class="mdi mdi-filter"></i></b-button>
              </span>
            </div>
            <div class="col-lg-12">
              <b-alert variant="warning" :show="filter.isPreview">
                <i class="mdi mdi-alert"></i> <b>Preview Data Attivo</b>
              </b-alert>
              <b-alert variant="info" :show="!isResultsEmpty">
                <i class="mdi mdi-information"></i> <b>Legenda delle regole:</b><br><br>
                <ul>
                  <li class="mb-1">(A) Autoselezione - Selezione automatica di un OPT</li>
                  <li class="mb-1">(C) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo C</li>
                  <li class="mb-1">(0 - 9) Complementarietà: regole utilizzate per creare altri legami complementari su OPT che presentano già regole di tipo C</li>
                  <li class="mb-1">(E) Esclusione: i due OPT si escludono a vicenda, non possono essere contemporaneamente selezionati</li>
                  <li class="mb-1">(A9) Restrizione della mazzetta colori ammessa</li>
                  <li class="mb-1">(E9) Selezione automatica di OPT con eventuale colore</li>
                  <li class="mb-1">(Q9) Limitazione alla disponibilità di OPT</li>
                </ul>
              </b-alert>
              <b-alert variant="warning" :show="isResultsEmpty">
                <i class="mdi mdi-alert"></i> <b>Nota:</b> Modello non attivo per il Market selezionato, reimpostare i filtri.
              </b-alert>
            </div>
            <template v-for="item in items">
              <b-table striped hover responsive :items="item.rows" :fields="item.gridHeader" no-local-sorting no-provider-paging sort-icon-left @head-clicked="item.show = !item.show" :class="{ 'hide-rows': !item.show }">
                <template v-slot:head()="data">
                  <div class="d-flex justify-content-between align-items-center">
                    <span>{{ data.label }}</span>
                    <i :class="'mdi mdi-chevron-' + (item.show ? 'up': 'down')"></i>
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <span class="text-left" v-html="data.value"></span>
                </template>
              </b-table>
              <br>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import { mapActions, mapGetters } from "vuex";
export default {
  name: 'grid_rules_check',
  methods: {
    search() {
      this.setLastSearch(this.search)
      this.setSpinnerStatus(true);
      var params = {country: this.filter.country.id, model: this.filter.model.value, configId: this.filter.configId, config: this.filter.config, isPreview: this.filter.isPreview};
      this.axios.get('/ccb/auth/api/checkGridJson/'+params.country+'/'+params.model, { params: params, ...this.authHeader })
        .then((response) => {
          this.setSpinnerStatus(false);
          if(response.data[0].gridHeader) {
            this.items = response.data.map((item) => ({
              gridHeader: [{key: 'checkRuleList', label: item.gridHeader, sortable: false, class: 'text-left', thStyle: {backgroundColor: '#0C2340', color: '#ffffff'}, formatter: this.formatter}], 
              rows: item.checkRuleList.map((row) => ({checkRuleList: row})),
              show: response.data.length == 1
            }));
            this.isResultsEmpty = false;
          } else {
            this.items = [];
            this.isResultsEmpty = true;
            this.$root.$emit('bv::toggle::collapse',   'grid_rules_check_filters')
          }
        })
        .catch(error => {
          this.setSpinnerStatus(false);
          console.error(error);
          this.items = [];
          this.isResultsEmpty = true;
          this.$root.$emit('bv::toggle::collapse',   'grid_rules_check_filters')
        })
    },
    formatter(value) {
      return value ? value
        .replace("checkRuleConsistency - ", "")
        .replace("Conflitto tra regole - ", "Conflitto tra regole:<br><br>")
        .replace("checkPackConsistency - ", "")
        .replace("Regola da PACK attesa ma non trovata: ", "Regola da PACK attesa ma non trovata:<br><br>")
        .replace("  --  ", "<br><br>")
        .replace("(0)", "(0) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo 0")
        .replace("(1)", "(1) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo 1")
        .replace("(2)", "(2) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo 2")
        .replace("(3)", "(3) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo 3")
        .replace("(4)", "(4) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo 4")
        .replace("(5)", "(5) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo 5")
        .replace("(6)", "(6) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo 6")
        .replace("(7)", "(7) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo 7")
        .replace("(8)", "(8) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo 8")
        .replace("(9)", "(9) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo 9")
        .replace("(A)", "(A) Autoselezione - Selezione automatica di un OPT")
        .replace("(C)", "(C) Complementarietà: obbligo di selezione di uno tra gli OPT dichiarati nel gruppo C")
        .replace("(E)", "(E) Esclusione: i due OPT si escludono a vicenda, non possono essere contemporaneamente selezionati")
        .replace("(A9)", "(A9) Restrizione della mazzetta colori ammessa")
        .replace("(E9)", "(E9) Selezione automatica di OPT con eventuale colore")
        .replace("(Q9)", "(Q9) Limitazione alla disponibilità di OPT")
        .replace("config", "Configuration") : value;
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus'
    ])
  },
  data() {
    return {
      items: [],
      filter: {
        country: null,
        model: null,
        configId: null,
        config: null,
        isPreview: false
      },
      countries: [],
      isResultsEmpty: false
    }
  },
  computed: {
    ...mapGetters([
      'authHeader',
      'getCurUser'
    ])
  },
  watch: {
    'filter.country': function(newVal) {
      if (newVal) {
        this.filter.model = newVal.modelGroupItemList[0].items[0];
      } else {
        this.filter.model = null;
      }
    }
  },
  mounted() {
    window.scoper = this;
    this.setCurApp('ccadm');
    var models = Object.values(
    this.getCurUser.countries.flatMap(country => country.modelGroupItemList).reduce((acc, group) => {
      if (acc[group.label]) {
        const existingValues = new Set(acc[group.label].items.map(i => i.value));
        acc[group.label].items.push(...group.items.filter(i => !existingValues.has(i.value)));
      } else {
        acc[group.label] = { ...group, items: [...group.items] };
      }
      return acc;
    }, {}));
    
    this.countries = [{id: 'MAIN', description: 'Main', modelGroupItemList: models}].concat(this.getCurUser.countries)
    this.filter.country = this.getCurUser.countries[0];
    if (this.filter.country) {
      this.filter.model = this.filter.country.modelGroupItemList[0].items[0];
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";

.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}

.text-left {
  text-align: left !important;
  white-space: break-spaces;
}
</style>
<style>
.grid_rules_check table tbody {
  display: block;
  overflow: hidden;
  max-height: 5000px;
  transition: max-height 0.35s ease-in-out;
}

.grid_rules_check table thead,
.grid_rules_check table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.hide-rows table tbody {
  max-height: 0;
}
</style>
